var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification",class:_vm.circleSize,style:(`background-color: ${_vm.color}`)},[_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }